import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      company: 'BCG',
      logoColor: 'text-green-600',
      text: `“Datalab's meticulous approach of breaking down a complex problem makes stands him apart. Their Financial services knowledge and ability to deal with diverse set of complex problem statement and provide the necessary context helped us in our research and strategy project”`
    },
    {
      company: 'Third Bridge.',
      logoColor: 'text-black',
      text: `“It was a pleasure to work with Datalab team, Very timely in their response and helped our client massively with their project. Would recommend highly for any future projects.”`
    },
    {
      company: 'COLEMAN',
      logoColor: 'text-black',
      text: `“Datalab team was great to work with! They provided an insightful perspective to my client, and was very responsive throughout the process. Looking forward to future opportunities to collaborate.”`
    },
  ];

  return (
    <section className="bg-white py-16 px-4 sm:px-6 md:px-12 lg:px-20" id="resources">
      <div className="w-full">
        <h2 className="text-2xl sm:text-3xl md:text-6xl font-semibold text-gray-900 mb-4 text-left">
          What Our Clients Say About Us
        </h2>
        <p className="text-lg sm:text-xl md:text-2xl text-gray-700 mb-10 md:mb-14 font-[400] leading-relaxed w-full md:w-[60%] text-left">
          We help you see the world differently, discover opportunities you may never have imagined and achieve results that bridge what is with what can be.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((item, idx) => (
            <div
              key={idx}
              className="bg-gray-50 rounded-lg p-6 sm:p-8 text-left shadow-sm transition duration-300 hover:shadow-md"
            >
              <h3 className={`text-xl sm:text-2xl md:text-4xl font-bold mb-3 sm:mb-4 ${item.logoColor}`}>
                {item.company}
              </h3>
              <p className="text-gray-700 text-base sm:text-lg md:text-xl font-[400] leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* Pagination dots */}
        <div className="flex justify-center mt-10 space-x-2">
          <span className="w-2.5 h-2.5 bg-orange-500 rounded-full"></span>
          <span className="w-2.5 h-2.5 border border-orange-500 rounded-full"></span>
          <span className="w-2.5 h-2.5 border border-orange-500 rounded-full"></span>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
